import { numberFormatter } from 'lib'

export const SALES_USERS_REVENUE_COLUMNS = [
  {
    label: 'Name',
    orderBy: 'name',
    render: ({ name }) => name
  },
  {
    label: 'MTD',
    orderBy: 'salesMtd',
    render: ({ salesMtd }) => `$ ${numberFormatter(salesMtd)}`
  },
  {
    label: 'QTD',
    orderBy: 'salesQtd',
    render: ({ salesQtd }) => `$ ${numberFormatter(salesQtd)}`
  },
  {
    label: 'YTD',
    orderBy: 'salesYtd',
    render: ({ salesYtd }) => `$ ${numberFormatter(salesYtd)}`
  },
  {
    label: 'T12',
    orderBy: 'salesT12',
    render: ({ salesT12 }) => `$ ${numberFormatter(salesT12)}`
  }
]

export const PREVIOUS_REVENUE_COLUMNS = [
  {
    label: 'Name',
    orderBy: 'name',
    render: ({ name }) => name
  },
  {
    label: 'MTD',
    orderBy: 'mtd',
    render: ({ mtd }) => `$ ${numberFormatter(mtd)}`
  },
  {
    label: 'QTD',
    orderBy: 'qtd',
    render: ({ qtd }) => `$ ${numberFormatter(qtd)}`
  },
  {
    label: 'YTD',
    orderBy: 'ytd',
    render: ({ ytd }) => `$ ${numberFormatter(ytd)}`
  },
  {
    label: 'T12',
    orderBy: 't12',
    render: ({ t12 }) => `$ ${numberFormatter(t12)}`
  }
]
